
import { api } from '../services/api';
// import swal from 'sweetalert';

function toCents(n) { return Math.round(Number(n) * 100); }
function fromCents(c) { return (c / 100); }

async function finishCustomerOrder(
  user,
  cartBatches,           // [{ id, batch_id, amount, quantity }, ...]  // amount em BRL
  useCredit,
  userCredits,           // [{ amount }, ...]                           // BRL
  deliveryMethod,        // 'delivery' | 'pickup'
  paymentMethod,
  paymentObservations,
  deliveryAddress,
  deliveryAddressNumber,
  deliveryAddressComplement,
  couponDiscount,        // BRL (se % virá no couponKind)
  couponKind,            // 'fixed' | 'percentage' | null
  validCoupon,
  products,
  batches
) {
  // Trabalhe 100% em centavos
  const totalAmountCents = cartBatches.reduce((sum, { amount }) => sum + toCents(amount), 0);

  const dataObjectPayment = new FormData();
  dataObjectPayment.append('payment[created_at]', new Date());
  dataObjectPayment.append('payment[updated_at]', new Date());
  dataObjectPayment.append('payment[user_id]', user.id);
  dataObjectPayment.append('payment[payment_method]', paymentMethod);
  dataObjectPayment.append('payment[observations]', paymentObservations);
  if (couponDiscount > 0 && validCoupon?.coupon_id) {
    dataObjectPayment.append('payment[coupon_id]', validCoupon.coupon_id);
  }

  const paymentResponse = await api.post('/api/v1/payments', dataObjectPayment);
  // const firstPayment = paymentResponse.data.first_payment === true;
  console.log("PAYMENT RESPONSE", paymentResponse.data);



  // Rateios (em centavos)
  // let firstPurchaseDiscountTotal = firstPayment ? Math.round(totalAmountCents * 0.05) : 0; // 5%
  let creditsTotalCents = 0;
  if (useCredit) {
    creditsTotalCents = userCredits.reduce((n, { amount }) => n + toCents(amount), 0);
    const creditForm = new FormData();
    creditForm.append('credit[payment_id]', paymentResponse.data.payment.id);
    creditForm.append('credit[amount]', -fromCents(creditsTotalCents)); // API espera BRL?
    creditForm.append('credit[user_id]', user.id);
    await api.post('/api/v1/credits', creditForm);
  }

  // Frete
  const needsDeliveryFee = (fromCents(totalAmountCents) < 120.00) && deliveryMethod === 'delivery';
  const deliveryFeeTotalCents = needsDeliveryFee ? toCents(12.90) : 0;

  // Cupom
  const couponDiscountTotalCents =
    couponDiscount > 0
      ? (couponKind === 'fixed'
          ? toCents(couponDiscount)
          : Math.round(totalAmountCents * (Number(couponDiscount) / 100)))
      : 0;

  // Rateio uniforme por quantidade de itens (mesma regra que você aplicou)
  const L = cartBatches.length || 1;
  const perBatch = cartBatches.map((cb) => {
    const originalSubtotalCents = toCents(cb.amount);

    const deliveryFeePerBatchCents      = Math.floor(deliveryFeeTotalCents / L);
    const couponDiscountPerBatchCents   = Math.floor(couponDiscountTotalCents / L);
    const creditDiscountPerBatchCents   = Math.floor(creditsTotalCents / L);
    // const firstDiscountPerBatchCents    = Math.floor(firstPurchaseDiscountTotal / L);

    // Ajuste do último item para fechar centavos (evita 1–2 cents sobrando)
    const isLast = cb === cartBatches[cartBatches.length - 1];
    const adjust = (total, per) => total - per * (L - 1);

    const deliveryFeeCents   = isLast ? adjust(deliveryFeeTotalCents, deliveryFeePerBatchCents) : deliveryFeePerBatchCents;
    const couponCents        = isLast ? adjust(couponDiscountTotalCents, couponDiscountPerBatchCents) : couponDiscountPerBatchCents;
    const creditCents        = isLast ? adjust(creditsTotalCents, creditDiscountPerBatchCents) : creditDiscountPerBatchCents;
    // const firstDiscCents     = isLast ? adjust(firstPurchaseDiscountTotal, firstDiscountPerBatchCents) : firstDiscountPerBatchCents;

    const finalAmountCents = originalSubtotalCents + deliveryFeeCents - couponCents - creditCents;

    return {
      cart_batch_id: cb.id,
      batch_id: cb.batch_id,
      quantity: cb.quantity,
      breakdown: {
        originalSubtotalCents,
        deliveryFeeCents,
        couponDiscountCents: couponCents,
        creditDiscountCents: creditCents,
        // firstPurchaseDiscountCents: firstDiscCents,
        finalAmountCents
      }
    };
  });

  console.log("PER BATCH", perBatch);

  // Criação dos batch_orders usando o valor final do item (como já faz hoje)
  const promises = perBatch.map(async (pb) => {
    console.log("CRIANDO BATCH ORDER", pb);
    const d = new FormData();
    d.append('batch_order[amount]', fromCents(pb.breakdown.finalAmountCents).toFixed(2));
    d.append('batch_order[quantity]', pb.quantity);
    d.append('batch_order[user_id]', user.id);
    d.append('batch_order[batch_id]', pb.batch_id);
    d.append('batch_order[payment_id]', paymentResponse.data.payment.id);
    d.append('batch_order[delivery_method]', deliveryMethod);
    d.append('batch_order[delivery_status]', 'pending');

    if (pb.cart_batch_id) d.append('batch_order[cart_batch_id]', pb.cart_batch_id);

    // (Opcional e muito útil) Persistir metadados de breakdown no batch_order
    // Para isso, permita no Rails strong params:
    // params.require(:batch_order).permit(..., meta: {})
    d.append('batch_order[meta][original_subtotal_cents]', pb.breakdown.originalSubtotalCents);
    d.append('batch_order[meta][delivery_fee_cents]', pb.breakdown.deliveryFeeCents);
    d.append('batch_order[meta][coupon_discount_cents]', pb.breakdown.couponDiscountCents);
    d.append('batch_order[meta][credit_discount_cents]', pb.breakdown.creditDiscountCents);
    // d.append('batch_order[meta][first_purchase_discount_cents]', pb.breakdown.firstPurchaseDiscountCents);

    // Endereço de entrega
    if (deliveryMethod === 'delivery') {
      d.append('batch_order[delivery_address]',
        `${deliveryAddress.logradouro}, ${deliveryAddressNumber}, ${deliveryAddressComplement}, ${deliveryAddress.bairro} - ${deliveryAddress.localidade} - ${deliveryAddress.uf} CEP: ${deliveryAddress.cep}`
      );
    }

    return api.post('/api/v1/cart_batches/finish_my_order', d);
  });

  const responses = await Promise.all(promises);
  console.log("wewee", responses)

  if (responses.every((r) => r.data.status === 'created')) {
    return {
      success: true,
      paymentId: paymentResponse.data.payment.id,
      totalPrice: (paymentResponse.data.price_in_cents / 100),
      // firstPayment,
      totals: {
        deliveryFeeTotal: fromCents(deliveryFeeTotalCents),
        couponDiscountTotal: fromCents(couponDiscountTotalCents),
        creditDiscountTotal: fromCents(creditsTotalCents),
        // firstPurchaseDiscountTotal: fromCents(firstPurchaseDiscountTotal)
      },
      breakdownByBatch: perBatch  // ← use isso na UI
    };
  } else {
    return { success: false, message: 'Algo deu errado' };
  }
}

export { finishCustomerOrder };
